import { forwardRef } from "react"
import DownloadPayslipTemplate from "./DownloadPayslipTemplate"

const DownloadComToPrint = forwardRef(({ data }: any, ref: any) => {
  return (
    <div
      ref={ref}
      className=" pb-40"
      // id="report"
      // id="payslip"
    >
      <DownloadPayslipTemplate data={data} />
    </div>
  )
})

export default DownloadComToPrint
